"use strict";
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDisplayName = void 0;
function createDisplayName(wrapperTypeName, wrappedType) {
    // Ignoring the case for constructor.name in prod environment:
    return "".concat(wrapperTypeName, "(").concat(wrappedType.displayName || wrappedType.name || /* istanbul ignore next */ "Unknown", ")");
}
exports.createDisplayName = createDisplayName;
//# sourceMappingURL=Hoc.js.map